import React, {useState, useEffect, useRef, useContext } from 'react';
import {MapContext} from '_context/MapContext';
import {LayoutContext} from '_context/LayoutContext';
import {asEnumerable} from 'linq-es2015';
import util from 'common/util';
import Map from 'ol/Map';
import View from 'ol/View';
import {Tile, Vector as VectorLayer} from 'ol/layer';
import XYZ from 'ol/source/XYZ';
import Projection from 'ol/proj/Projection'
import TileGrid from 'ol/tilegrid/TileGrid'
import {Icon, Style, Stroke} from 'ol/style';
import Feature from 'ol/Feature';
import {Point, LineString} from 'ol/geom';
import VectorSource from 'ol/source/Vector';
import 'ol/ol.css';

const OlSimulateMap = (props) => {
    const {routes, rpOpts} = useContext(MapContext)
    const {status} = useContext(LayoutContext)
    const mapIns = useRef(null)
    const [init, setInit] = useState(null)
    const simulMapArea = useRef()
    const route = useRef()
    const marker = useRef()
    const polyline1 = useRef()
    const polyline2 = useRef()
    const timer = useRef()
    const scene = useRef({points:null, totalCnt:0, groupNum:0, remember:0})
    const [playing, setPlaying] = useState(false)
    const [roadName, setRoadName] = useState('')
    const [progress, setProgress] = useState('0%')
    const playSpeed = useRef(4)
    const [playSpeedSelect, setPlaySpeedSelect] = useState(false)
    const roadViewArea = useRef()
    const roadViewImg = useRef()
    const tbtViewImg = useRef()
    const tbtViewText = useRef()
    const farTbtViewImg = useRef()
    const [roateMode, setRoateMode] = useState(false)

    useEffect(() => {
        if(init) return;
        setInit(true)
        let resolutions = [2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5, 0.25];
        let extent = [171162, 1214781, 1744026, 2787645]
        let projection = new Projection({code: 'EPSG:5179',extent: extent})
        let ktMap = new Tile({title:'KTMap', visible:true, type:'base', preload:10,
            source : new XYZ({
                projection: projection,
                tileSize: 256,
                tileGrid: new TileGrid({extent: extent,origin: [extent[0], extent[3]],resolutions: resolutions}),
                tileUrlFunction: (tileCoord, pixelRatio, projection) => {
                    if (tileCoord == null) return undefined;
                    return 'https://tile.gis.kt.com/current/base.default/' + tileCoord[0] + '/' + tileCoord[2] + '/' + tileCoord[1] + '.png';
                }
            })
        });
        mapIns.current = new Map({
            layers: [ktMap],
            target: simulMapArea.current,
            view: new View({projection:projection, extent:extent, resolutions:resolutions, maxResolution:resolutions[0], minResolution:resolutions[13],
                zoomFactor:1, center:[957181.016, 1943712.783], zoom:11, maxZoom:13
            })
        });
        console.log(mapIns.current.getControls().zoom )
        marker.current = new Feature();
        marker.current.setStyle(new Style({
            image: new Icon({src:'images/point.png', scale:0.04, anchor:[0.5, 0.5], anchorXUnits:'fraction', anchorYUnits:'fraction'})
        }));
        polyline1.current = new Feature();
        polyline1.current.setStyle(new Style({stroke:new Stroke({color:'#7725ff',width:8})}));
        polyline2.current = new Feature();
        polyline2.current.setStyle(new Style({stroke:new Stroke({color:'#ffffff',width:1, lineDash:[6, 4]})}));
        mapIns.current.addLayer(new VectorLayer({source: new VectorSource({features:[marker.current, polyline1.current, polyline2.current]})}))
    }, [init]);

    useEffect(() => {
        if(status==='simul' && mapIns.current){
            ready()
        }else{
            scene.current.groupNum = scene.current.remember = 0
            setPlaying(false)
        }
    }, [status]);

    useEffect(() => {
        playing ? play() : stop()
    }, [playing]);

    useEffect(() => {
        stop()
        if(playing){play()}
    }, [roateMode]);

    const ready = () => {
        setProgress('0%'); setRoadName('');
        roadViewArea.current.style.display = tbtViewImg.current.style.display = tbtViewText.current.style.display = farTbtViewImg.current.style.display ='none'

        route.current = routes.filter((route) => {if(route.rpType===rpOpts.rpType) return route;})[0]
        if(mapIns.current){
            marker.current.setGeometry(new Point([route.current.tbts[0].tbtLinkX, route.current.tbts[0].tbtLinkY]))
            mapIns.current.getView().setCenter([route.current.tbts[0].tbtLinkX, route.current.tbts[0].tbtLinkY] );
            mapIns.current.getView().setRotation(0) 
            routeDraw()
        }
        [scene.current.points, scene.current.totalCnt] = makePaths()
        scene.current.groupNum = scene.current.remember = 0
    }

    const routeDraw = (routes=route.current['polyline'].getPath()._coords)=>{
        let extent = mapIns.current.getView().calculateExtent()
        let drawPaths = asEnumerable(routes).Where((point) => {
            if(extent[2]+1000>point.x && extent[3]+1000>point.y && extent[0]-1000<point.x && extent[1]-1000<point.y ){
                return true
            }
        }).ToArray()
        let lineString = new LineString(makeLineString(drawPaths))
        polyline1.current.setGeometry(lineString)
        polyline2.current.setGeometry(lineString)
    }

    const makeLineString = (paths)=>{
        let result = []
        paths.some((path)=>{
            result.push([path.x, path.y])
            return false
        })
        return result
    }

    const jumpStep = (step) => {
        roadViewArea.current.style.display = 'none'
        if((step===-1 && scene.current.groupNum===0) || (step===1 && scene.current.groupNum===scene.current.points.length)){
            return
        }
        stop()
        scene.current.groupNum += step; scene.current.remember = 0
        playing ? play() : move()
    }

    const playAndStop = () => {
        if(scene.current.groupNum===scene.current.points.length){
            scene.current.groupNum = scene.current.remember = 0
        }
        setPlaying(!playing)
    }

    const stop = () => {
        document.getElementsByClassName('ol-zoom ol-unselectable ol-control')[0].style.display = ''
        if(timer.current)
            clearInterval(timer.current)
    }

    const play = () => {
        document.getElementsByClassName('ol-zoom ol-unselectable ol-control')[0].style.display = 'none'
        scene.current.groupNum===scene.current.points.length ? setPlaying(false) : execute()
    }

    const roateClick = () => {
        if(roateMode){
            mapIns.current.getView().setRotation(0)
        }else{
            let tbtByPaths = scene.current.points[scene.current.groupNum]
            let partPath = pointsSprit(tbtByPaths)
            let sceneNum = 0
            if(scene.current.remember!==0){
                sceneNum = scene.current.remember
            }
            let po = partPath[sceneNum]
            let nextPo = partPath[sceneNum+1]
            mapIns.current.getView().setRotation(-1*Math.atan2(nextPo.x - po.x, nextPo.y - po.y)) 
        }
        setRoateMode(!roateMode)
    }

    const move = () => {
        let po = null
        if(scene.current.groupNum===scene.current.points.length){
            let partP = scene.current.points[scene.current.groupNum-1]
            po = partP[partP.length-1]
        }else{
            po = scene.current.points[scene.current.groupNum][0]
        }
        marker.current.setGeometry(new Point([po.x, po.y])); mapIns.current.getView().setCenter([po.x, po.y]);
        setProgress((po.num*100/scene.current.totalCnt).toFixed(1) + '%')
        routeDraw()
    }

    const execute = () => {
        if(timer.current){
            clearInterval(timer.current)
        }
        let tbtByPaths = scene.current.points[scene.current.groupNum]
        let nextTbtPoint= null
        let farTbtPoint= null
        if(scene.current.groupNum+1<scene.current.points.length){
            nextTbtPoint = scene.current.points[scene.current.groupNum+1][0]
        }
        if(scene.current.groupNum+2<scene.current.points.length){
            farTbtPoint = scene.current.points[scene.current.groupNum+2][0]
        }
        let partPath = pointsSprit(tbtByPaths)
        let sceneNum = 0
        if(scene.current.remember!==0){
            sceneNum = scene.current.remember
        }
        timer.current = setInterval(()=>{
            try{
                if(sceneNum === partPath.length){
                    clearInterval(timer.current)
                    scene.current.groupNum += 1; scene.current.remember = 0
                    play()
                    return;
                }
                //마커이동 및 지도이동
                let po = partPath[sceneNum]
                marker.current.setGeometry(new Point([po.x, po.y])); mapIns.current.getView().setCenter([po.x, po.y]);

                //지도회전
                if(roateMode && sceneNum<partPath.length-1){
                    let nextPo = partPath[sceneNum+1]
                    mapIns.current.getView().setRotation(-1*Math.atan2(nextPo.x - po.x, nextPo.y - po.y)) 
                }

                //경로라인 그리기
                if(po['nodeNum']===0 || po['num']%2===0){
                    routeDraw()
                }

                //progress update
                if(po['num']){
                    setProgress((po.num*100/scene.current.totalCnt).toFixed(1) + '%')
                } 

                if(po['roadViewFile']==='close'){
                    roadViewArea.current.style.display = 'none'
                }else if(typeof po['roadViewFile'] === 'object'){ 
                    roadViewArea.current.style.display = 'block'
                    roadViewImg.current.src = `https://rg.gis.kt.com/resource/img/day/${po['roadViewFile']['file']}.png`
                }

                //tbt이미지
                if(po['tbt'] && nextTbtPoint && nextTbtPoint['tbt']){
                    tbtViewImg.current.style.display = 'block'
                    tbtViewImg.current.src = 'images/tbt-images/' + util.tbtIcon['type_'+nextTbtPoint['tbt']['type']] + '.png'
                    tbtViewText.current.style.display = 'block'
                    tbtViewText.current.textContent = nextTbtPoint['tbt']['displayName']
                }

                //fatTbt이미지
                if(po['tbt'] && farTbtPoint && farTbtPoint['tbt']){
                    farTbtViewImg.current.style.display = 'block'
                    farTbtViewImg.current.src = 'images/tbt-images/' + util.tbtIcon['type_'+farTbtPoint['tbt']['type']] + '.png'
                }
                if(farTbtPoint===null){
                    farTbtViewImg.current.style.display = 'none'
                }
                sceneNum++
                scene.current.remember++
            }catch(e){
                clearInterval(timer.current)
                setPlaying(false)
            }
        }, calSpeed(playSpeed.current)) //40, 20, 10, 1 //예전 Math.pow(8/playSpeed.current, 2)
    }

    const makePaths = () => {
        let paths = []
        let partPaths = null
        let result = route.current['polyline'].getPath()._coords
        route.current.tbts.some((tbt) => {
            let matchArr = asEnumerable(result).Where((dd) => {if(dd.x===tbt.tbtLinkX && dd.y===tbt.tbtLinkY) return true; else return false}).ToArray()
            if(matchArr.length === 0){
                let point = asEnumerable(result).Where((dd) => {if(dd.linkNum===tbt.linkIndex && dd.nodeNum===0) return true; else return false}).ToArray()
                if(point.length>0){
                    point[0]['tbt'] = tbt
                }
            }else{
                matchArr[0]['tbt'] = tbt
            }
            return false
        })
        result.some((point) => {
            if(point['tbt']){
                partPaths = []
                paths.push(partPaths)
            }
            partPaths.push(point)
            return false
        })
        //상세모식도 삽입
        let resultEnu = asEnumerable(result).Where((dd) => {if(dd.linkPart==='e') return true; else return false})
        let roadViewFileEun = asEnumerable(route.current.roadView.files)
        resultEnu.join(roadViewFileEun, _result=>_result.linkNum, _roadViewFile=>_roadViewFile.linkIndex, (_result, _roadViewFile) => {
            _result['roadViewFile']='close'; 
            result.some((rr) => {
                if(rr.linkNum===_result.linkNum || rr.linkNum<_result.linkNum || !rr['roadViewFile']) {
                    if(twoPointLength(rr, _result)<200){
                        rr['roadViewFile']=_roadViewFile; 
                        return true
                    }
                }
                return false
            })
            return _result
        }).ToArray()

        return [paths, result.length]
    }

    const pointsSprit = (tbtByPaths) => {
        let partPath = []
        tbtByPaths.some((point, idx) => {
            if(point['roadName']){
                setRoadName(point['roadName'])
            }
            partPath.push(point)
            if(idx < tbtByPaths.length-1){
                let netxPoint = tbtByPaths[idx+1]
                let length = twoPointLength(point, netxPoint)
                if(length>0.1){
                    towPointSpint(point, netxPoint, length, partPath)
                }
            }
        })
        return partPath;
    }

    const twoPointLength = (p1, p2) => {
        return Math.sqrt(Math.pow(Math.abs(p1.x-p2.x),2) + Math.pow(Math.abs(p1.y-p2.y),2))
    }

    const towPointSpint = (p1, p2, length, result) => {
        let max = Math.round(length)
        for (let i=1; i<max-1; i++){
            result.push({x:(p2.x * (i)/max) + (p1.x * (max-i)/max), y:(p2.y * (i)/max) + (p1.y * (max-i)/max)})
        }
    }

    const speedChange = (speed) => {
        let cloneplaying = playing
        if(cloneplaying){
            stop(); 
        }
        playSpeed.current=speed; 
        if(cloneplaying){
            play(); 
        }
        setPlaySpeedSelect(false);
    }

    const calSpeed = (speed) => {
        if(speed === 8)
            return 1;
        else if(speed === 4)
            return 8
        else if(speed === 2)
            return 16
        else if(speed === 1)
            return 32
    }

    return(
        <>
        <div className="tbtView">
            <img ref={tbtViewImg} style={{width:'80px', height:'80px', float:'left'}}/>
            <div style={{height:'90px', paddingTop:'30px'}}>
                <span ref={tbtViewText} style={{color:'#fff', fontSize:'22px'}}></span>
            </div>
        </div>
        <div className="farTbtView">
            <img ref={farTbtViewImg} style={{width:'80px', height:'80px', float:'left'}}/>
        </div>
        <div className="roadView" ref={roadViewArea} style={{display:'none'}}>
            <img ref={roadViewImg}/>
        </div>
        <div className="plugin-scrollbar-bd">
            <div className="plugin-scrollbar">
                <div ref={simulMapArea} style={{width: '100%',height: '100%'}}/>
            </div>
        </div>
        <div className="botWrap">
            <div className="progressBg">
                <div className="progressBar" style={{left:progress}}></div>
                <span className="current">{roadName}</span>
            </div>
            <div className="control">
                <div style={{position:'absolute', top:'10px', left:'18px'}}>
					<font style={{textDecoration:roateMode?'':'line-through', cursor:'pointer'}} onClick={(e) => roateClick()}>회전</font>
				</div>
                <div className="playPause">
                    <button className="btnsOneNavi btnRR" onClick={(e) => jumpStep(-1)}>뒤로</button>
                    <button className={"btnsOneNavi btnPlay" + (playing?' btnPause':'')} onClick={(e) => playAndStop()}>진행/일시정지</button> 
                    <button className="btnsOneNavi btnFF" onClick={(e) => jumpStep(1)}>앞으로</button>
                </div>
                <div className="ctrlRight">
                    <div className="zoom">
                        <button className="btnZoom" onClick={(e) => setPlaySpeedSelect(!playSpeedSelect)}> 
                            <span>{(playSpeed.current===4?2:1) + 'X'}</span>
                            <span className="iconsArrow"></span>
                        </button>
                        <ul style={{display:playSpeedSelect?'block':'none'}}>
                            {/* <li><a href="#" onClick={(e) => speedChange(8)}>8X</a></li>
                            <li><a href="#" onClick={(e) => speedChange(4)}>4X</a></li>
                            <li><a href="#" onClick={(e) => speedChange(2)}>2X</a></li>
                            <li><a href="#" onClick={(e) => speedChange(1)}>1X</a></li> */}
                            <li><a href="#" onClick={(e) => speedChange(4)}>2X</a></li>
                            <li><a href="#" onClick={(e) => speedChange(2)}>1X</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default OlSimulateMap